import  {lazy} from "react";


const SelectCheckbox=  lazy(() => import("./Select.Checkbox"));
const Select=  lazy(() => import("./Select"));

export {Select, SelectCheckbox};
